import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d6c9506"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_3 = {
  rowspan: "2",
  class: "type"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "K11 MUSEA", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "link" }, "(852) 3892 3890", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "D·PARK", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "link" }, "(852) 2940 2822", -1))
const _hoisted_8 = {
  rowspan: "3",
  class: "type"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "link" }, "(852) 9385 7156", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "link" }, "(852) 9298 0728", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "link" }, "(852) 6819 9343", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", null, [
      _createElementVNode("tr", null, [
        _hoisted_2,
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('礼遇合作方')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('联系电话')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('地址')), 1)
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.$t('停车礼遇')), 1),
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("td", null, _toDisplayString(_ctx.$t('尖沙咀梳士巴利道18号')), 1)
      ]),
      _createElementVNode("tr", null, [
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("td", null, _toDisplayString(_ctx.$t('香港荃湾青山公路-荃湾段398号')), 1)
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$t('汽车洗护礼遇')), 1),
        _createElementVNode("td", null, _toDisplayString(_ctx.$t('Champion Auto Club （铜锣湾）')), 1),
        _hoisted_9,
        _createElementVNode("td", null, _toDisplayString(_ctx.$t('铜锣湾皇室大厦停车场1楼')), 1)
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, _toDisplayString(_ctx.$t('Champion Auto Club （柴湾）')), 1),
        _hoisted_10,
        _createElementVNode("td", null, _toDisplayString(_ctx.$t('香港柴湾新业街8号八号商业广场地下16号铺')), 1)
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, _toDisplayString(_ctx.$t('Champion Auto Club （佐敦）')), 1),
        _hoisted_11,
        _createElementVNode("td", null, _toDisplayString(_ctx.$t('佐敦上海街17号地铺')), 1)
      ])
    ])
  ]))
}